import { Component, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { ApiServiceService } from 'src/app/api-service.service';
import { AppUtility } from 'src/app/interceptor/appUtitlity';
import { DatePipe } from '@angular/common'
import { Router } from '@angular/router';
import { FilterService } from 'primeng/api';
@Component({
  selector: 'app-jde-data-listing',
  templateUrl: './jde-data-listing.component.html',
  styleUrls: ['./jde-data-listing.component.scss'],
  providers: [DatePipe]
})
export class JdeDataListingComponent {
  breadcrumb = [
    {
      title: 'Open PO Details',
      subTitle: 'Dashboard'
    }
  ]

  supplierList: any = [];
  excelData: any[] = [];
  filteredXLSData: any[] = [];
  orderCo: any
  jdedata: any[] = []
  orderLineStatus: any;
  filterval: string
  filteredJdeData: any[];
  entyDate: any;
  orderNumber: any;
  orderType: string;
  dateUpdated: any;
  foreignUnitCost: any;
  exchangeRate: any;
  currency: any;
  glOffset: any;
  buyerNumber: any;
  invoiceNumber: any;
  paymentTerm: any;
  paymentTermsDesc: any;
  extendedPrice: any;
  unitPrice: any;
  quantityOpen: any;
  quantityremaining: number;
  quantityOrdered: any;
  unitOfMeasure: any;
  valueStream2: any;
  valueStream1: any;
  valueStreamDesc: any;
  valueStream: any;
  lastStatusDesc: any;
  lastStatus: any;
  nextStatusDesc: any;
  nextStatus: any;
  lineType: any;
  description2: any;
  description1: any;
  foreignExtendedPrice: any;
  orderSuffix: any;
  lineNumber: any;
  businessUnit: any;
  addressNumber: any;
  billToName: any;
  shipToNumber: any;
  shipToName: any;
  orderDate: any;
  requestedDate: any;
  scheduledPickDate: any;
  cancelDate: any;
  shortItemNumber: any;
  itemNumber: any;
  userroleName: any;
  isAllSelected: boolean = false;

  constructor(private _apiService: ApiServiceService, public _utility: AppUtility, private datePipe: DatePipe,
    private router: Router, private filterService: FilterService) { }
  @ViewChild('dt2') dataTable: Table;
  ngOnInit(): void {
    this.userroleName = this._utility.getLocalStorageDetails();

    // ================== DATE FILTER ==================
    this.filterService.register('customDate', (value: any, filter: any): boolean => {
      if (!filter) return true;

      const rowDate = value ? new Date(value) : null;
      if (!rowDate || isNaN(rowDate.getTime())) return false;

      const stripTime = (d: Date) =>
        new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();

      // Regex: operator + date string (supports -, /, or year only)
      const match = filter.trim().match(/(>=|<=|>|<|=)?\s*([\d/ -]+)/);
      if (!match) return false;

      const operator = match[1] || '=';
      const input = match[2].replace(/\//g, '-'); // normalize slashes to dashes

      // If no operator is provided, do a substring match to allow partial date typing (like "08/24")
      if (!match[1]) {
        const dd = String(rowDate.getDate()).padStart(2, '0');
        const mm = String(rowDate.getMonth() + 1).padStart(2, '0');
        const yy = String(rowDate.getFullYear()).slice(-2);
        const yyyy = rowDate.getFullYear();
        
        const dateStr1 = `${dd}/${mm}/${yy}`;
        const dateStr2 = `${dd}/${mm}/${yyyy}`;
        const dateStr3 = `${dd}-${mm}-${yy}`;
        const dateStr4 = `${dd}-${mm}-${yyyy}`;
        const filterStr = filter.trim();

        return dateStr1.includes(filterStr) || dateStr2.includes(filterStr) ||
               dateStr3.includes(filterStr) || dateStr4.includes(filterStr) ||
               yyyy.toString().includes(filterStr);
      }

      // Parse input string into Date
      const parseDateString = (dateStr: string): Date | null => {
        const parts = dateStr.trim().split('-').map(p => parseInt(p, 10));

        // YYYY-MM-DD
        if (parts.length === 3 && parts[0] > 31 && parts[1] <= 12 && parts[2] <= 31) {
          return new Date(parts[0], parts[1] - 1, parts[2]);
        }

        // DD-MM-YYYY or DD-MM-YY
        if (parts.length === 3 && parts[0] <= 31 && parts[1] <= 12) {
          let year = parts[2];
          if (year < 100) {
            year += 2000;
          }
          return new Date(year, parts[1] - 1, parts[0]);
        }

        // MM-YYYY or MM-YY
        if (parts.length === 2 && parts[0] <= 12) {
          let year = parts[1];
          if (year < 100) year += 2000;
          return new Date(year, parts[0] - 1, 1);
        }

        // Year only
        if (parts.length === 1) {
          let year = parts[0];
          if (year < 100 && year > 0) year += 2000;
          return new Date(year, 0, 1);
        }

        return null;
      };

      const filterDate = parseDateString(input);
      if (!filterDate || isNaN(filterDate.getTime())) return false;

      const rowTime = stripTime(rowDate);
      const filterTime = stripTime(filterDate);

      switch (operator) {
        case '>': return rowTime > filterTime;
        case '<': return rowTime < filterTime;
        case '>=': return rowTime >= filterTime;
        case '<=': return rowTime <= filterTime;
        case '=': return rowTime === filterTime;
        default: return false;
      }
    });




    // ================== NUMBER FILTER ==================
    this.filterService.register('customNumber', (value: any, filter: any): boolean => {
      if (!filter) return true;

      // Match optional operator + number
      const match = filter.trim().match(/^\s*(>=|<=|>|<|=)?\s*(\d+(\.\d+)?)/);
      if (!match) return true;

      const operator = match[1];
      const filterValue = parseFloat(match[2]);
      const numericValue = parseFloat(String(value).replace(/,/g, '').trim()); // clean commas/spaces

      if (isNaN(numericValue)) return false;

      if (!operator) {
        // No operator → substring match
        return numericValue.toString().includes(filterValue.toString());
      }

      switch (operator) {
        case '>': return numericValue > filterValue;
        case '<': return numericValue < filterValue;
        case '>=': return numericValue >= filterValue;
        case '<=': return numericValue <= filterValue;
        case '=': return numericValue === filterValue;
        default: return true;
      }
    });




    this.getdata();
  }


  getdata() {
    this._utility.loader(true);
    this._apiService.getjdedata()
      .then((res: any) => {
        console.log(res);
        if (res.success) {
          this.jdedata = res.returnValue;
          console.log(this.jdedata);
        } else {
          this.jdedata = [];
        }
      })
      .catch((error) => {
        this._apiService.showMessage(error.message, "error");
        this.jdedata = [];
      })
      .finally(() => {
        this._utility.loader(false);
      });
  }


  isExchangeRateValid(exchangeRate: any): string | number {
    // Check if exchangeRate is a valid number, return it if true, otherwise return '-'
    return typeof exchangeRate === 'number' ? exchangeRate : '- ';
  }

  reset(dt2) {
    dt2.reset();
    this.filterval = ''
    this.orderCo = ''
    this.orderNumber = ''
    this.orderType = ''
    this.dateUpdated = ''
    this.foreignUnitCost = ''
    this.exchangeRate = ''
    this.currency = ''
    this.glOffset = ''
    this.buyerNumber = ''
    this.invoiceNumber = ''
    this.paymentTerm = ''
    this.paymentTermsDesc = ''
    this.extendedPrice = ''
    this.unitPrice = ''
    this.quantityOpen = ''
    this.quantityremaining = null
    this.quantityOrdered = ''
    this.unitOfMeasure = ''
    this.valueStream2 = ''
    this.valueStream1 = ''
    this.valueStreamDesc = ''
    this.valueStream = ''
    this.lastStatusDesc = ''
    this.lastStatus = ''
    this.nextStatusDesc = ''
    this.nextStatus = ''
    this.lineType = ''
    this.description2 = ''
    this.description1 = ''
    this.foreignExtendedPrice = ''
    this.orderSuffix = ''
    this.lineNumber = ''
    this.businessUnit = ''
    this.addressNumber = ''
    this.billToName = ''
    this.shipToNumber = ''
    this.shipToName = ''
    this.orderDate = ''
    this.requestedDate = ''
    this.scheduledPickDate = ''
    this.cancelDate = ''
    this.shortItemNumber = ''
    this.itemNumber = ''
    this.entyDate = ''
    this.orderLineStatus = ''
  }
  onXLSExport() {
    let filteredBy

    for (let i = 0; i < this.jdedata.length; i++) {

      this.excelData.push({
        'S.No.': i + 1,
        'Order Co': this.jdedata[i]?.orderCo ?? '-',
        'Order Number': this.jdedata[i]?.orderNumber ?? '-',
        'Order Type': this.jdedata[i]?.orderType ?? '-',
        'Order Suffix': this.jdedata[i]?.orderSuffix ?? '-',
        'Line Number': this.jdedata[i]?.lineNumber ?? '-',
        'Business Unit': this.jdedata[i]?.businessUnit ?? '-',
        'Address Number': this.jdedata[i]?.addressNumber ?? '-',
        'Bill To Name': this.jdedata[i]?.billToName ?? '-',
        'Ship To Number': this.jdedata[i]?.shipToNumber ?? '-',
        'Ship to Name': this.jdedata[i]?.shipToName ?? '-',
        'Order Date': this.datePipe.transform(this.jdedata[i]?.orderDate, 'MM/dd/yyyy') ?? '-',
        'Requested Date': this.datePipe.transform(this.jdedata[i]?.requestedDate, 'MM/dd/yyyy') ?? '-',
        'Scheduled Pick Date': this.datePipe.transform(this.jdedata[i]?.scheduledPickDate, 'MM/dd/yyyy') ?? '-',
        'Cancel Date': this.datePipe.transform(this.jdedata[i]?.cancelDate, 'MM/dd/yyyy') ?? '-',
        'Short Item Number': this.jdedata[i]?.shortItemNo ?? '-',
        'Item Number': this.jdedata[i]?.itemNumber ?? '-',
        'Description 1': this.jdedata[i]?.itemDesc ?? '-',
        'Description 2': this.jdedata[i]?.itemDesc2 ?? '-',
        'Line Type': this.jdedata[i]?.lineType ?? '-',
        'Next Status': this.jdedata[i]?.nextStatus ?? '-',
        'Next Status Desc': this.jdedata[i]?.nextStatusDesc ?? '-',
        'Last Status': this.jdedata[i]?.lastStatus ?? '-',
        'Last Status Desc': this.jdedata[i]?.lastStatusDesc ?? '-',
        'Value Stream': this.jdedata[i]?.valueStream ?? '-',
        'Value Stream Desc': this.jdedata[i]?.valueStreamDesc ?? '-',
        'Value Stream 1': this.jdedata[i]?.valueStream1 ?? '-',
        'Value Stream 2': this.jdedata[i]?.valueStream2 ?? '-',
        'Unit Of Measure': this.jdedata[i]?.um ?? '-',
        'Quantity Ordered': this.jdedata[i]?.quantityOrdered ?? '-',
        'Quantity Open': this.jdedata[i]?.quantityOpen ?? '-',
        'Quantity Remaining': this.jdedata[i]?.ASNRemainingQuantity ?? '-',
        'Unit Price': this.jdedata[i]?.unitPrice ?? '-',
        'Extended Price': this.jdedata[i]?.extendedPrice ?? '-',
        'Payment Term': this.jdedata[i]?.paymentTerm ?? '-',
        'Payment Term Desc': this.jdedata[i]?.paymentTermsDesc ?? '-',
        'Invoice Number': this.jdedata[i]?.invoiceNumber ?? '-',
        'Buyer Number': this.jdedata[i]?.buyerNumber ?? '-',
        'GL Offset': this.jdedata[i]?.glOffset ?? '-',
        'Currency': this.jdedata[i]?.currency ?? '-',
        'Exchange Rate': this.jdedata[i]?.exchangeRate ?? '-',
        'Foreign Unit Cost': this.jdedata[i]?.foreignUnitCost ?? '-',
        'Foreign Extended Price': this.jdedata[i]?.foreignExtendedPrice ?? '-',
        'Entry Date': this.datePipe.transform(this.jdedata[i]?.entyDate, 'MM/dd/yyyy') ?? '-',
        'Order Line Status': this.jdedata[i]?.orderLineStatus ?? '-',
        'Date Updated': this.datePipe.transform(this.jdedata[i]?.dateUpdated, 'MM/dd/yyyy') ?? '-'
      });


    }
    this._apiService.exportExcel(this.excelData, 'JDE-list', filteredBy);
  }
  sendSelectedData() {
    const selectedData = this.jdedata.filter(item => item.selected);
    console.log(selectedData);

    if (selectedData.length > 0) {
      this._utility.loader(true);

      // Use setTimeout to allow the browser to render the loading state
      // before the main thread gets busy with the heavy ASN generation form initialization.
      setTimeout(() => {
        this._apiService.setSelectedData(selectedData);
        this.router.navigate(['/asn-generation']).then(() => {
          this._utility.loader(false);
        }).catch(() => {
          this._utility.loader(false);
        });
      }, 100);
    } else {
      this._apiService.showMessage('please select atleast one checkbox', 'error');

    }
  }

  selectAll(event: any) {
    const isChecked = event.target.checked;
    const dataToSelect = (this.dataTable && this.dataTable.filteredValue) ? this.dataTable.filteredValue : this.jdedata;
    dataToSelect.forEach(item => {
      if (item.asnRemainingQuantity != 0 && item.orderLineStatus != 'Cancelled' && item.orderLineStatus != 'QtyError') {
        item.selected = isChecked;
      }
    });
  }
}
